import { Modal } from "react-bootstrap";
import CustomSvg from "../../svgs/CustomSvg";
import Loader1 from "../../loaders/Loader1";
import { useEffect } from "react";

export default function SuccessModal({ modalProps, redirectFunc, subTxt, accountType }) {
  const { visible, onHide, size } = modalProps;

  useEffect(() => {
    if (visible) {
      const redirectDelay = setTimeout(() => {
        redirectFunc();
      }, 3000);
      return () => clearTimeout(redirectDelay);
    }
  }, [visible, redirectFunc]);

  const isCelebrity = accountType === "celebrity";

  return (
    <Modal
      show={visible}
      onHide={onHide}
      size={size || "sm"}
      centered
      backdrop="static"
      keyboard={false}
      className="!bg-transparent z-[1050]"
      contentClassName="border-0 bg-transparent"
      dialogClassName="m-0"
    >
      <div
        className={`flex flex-col items-center justify-center rounded-2xl shadow-xl p-8 ${
          isCelebrity ? "bg-white" : "bg-white"
        }`}
      >
        <div className="mb-4 flex items-center justify-center">
          <CustomSvg
            name={
              isCelebrity
                ? "registration-success-celebrity"
                : "registration-success-user"
            }
          />
        </div>

        <h4
          className={`text-center font-quantico font-bold text-2xl mb-4 ${
            isCelebrity
              ? "bg-gradient-to-r from-[#56920D] to-[#B7D080] bg-clip-text text-transparent"
              : "text-black"
          }`}
        >
          Successful!
        </h4>

        <p
          className={`text-center font-poppins text-base mb-4 ${
            isCelebrity ? "text-[#130828]" : "text-black"
          }`}
        >
          {subTxt}
        </p>

        <div className="py-4 flex items-center justify-center">
          <Loader1 accountType={accountType} />
        </div>
      </div>
    </Modal>
  );
}
